import React from 'react';
import { Box, Typography } from '@mui/material';
import { COLORS } from '../../pages/app/reports/groups-teams-activity/constants';

interface TagPillsProps {
    tags: string[];
}

export const TagPills: React.FC<TagPillsProps> = ({ tags }) => {
    if (!tags.length) return null;

    return (
        <Box sx={{ display: 'flex', gap: '3px', marginTop: '2px', flexWrap: 'wrap' }}>
            {tags.map((tag) => (
                <Typography
                    key={tag}
                    component="span"
                    sx={{
                        fontSize: '9px',
                        padding: '1px 6px',
                        borderRadius: '8px',
                        backgroundColor: COLORS.grayLight,
                        color: COLORS.grayDark,
                        fontWeight: 500,
                        whiteSpace: 'nowrap',
                    }}
                >
                    {tag}
                </Typography>
            ))}
        </Box>
    );
};
